import { useRestClient } from '@/contexts/QueryProvider'
import { ApplicationsBreadcrumb } from '@/pages/Applications/ApplicationsBreadcrumbs'
import { useCurrentApplication } from '../useCurrentApplication'
import { MenuTable } from './MenuTable'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Suspense } from 'react'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { parseMenuItems } from './utils'

export function MenuBuilderPage() {
  return (
    <>
      <ApplicationsBreadcrumb title="Menu builder" />
      <QueryErrorBoundary errorMessage="Failed to fetch menu">
        <Suspense fallback={<DataTableLoading />}>
          <AppMenuBuilderPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function AppMenuBuilderPanelContent() {
  const { applicationId } = useCurrentApplication()
  const { getUiApiGetMenu } = useRestClient()
  const { data } = getUiApiGetMenu.useSuspenseQuery({
    path: { applicationId, grouping: 'menu' },
  })
  return (
    <div className="pt-5">
      <MenuTable data={parseMenuItems(data?.definition)} />
    </div>
  )
}
